import { Spinner } from "@/components/feedback/Spinner";

export function FullScreenLoader({ message = "Loading FI Radar…" }: { message?: string }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        background: "var(--color-bg)",
        color: "var(--color-text-secondary)",
      }}
    >
      <Spinner size="lg" label={message} />
      <p style={{ fontSize: "0.875rem" }}>{message}</p>
    </div>
  );
}
